import { useEffect, useState } from "react";
import { ItemMenu } from "../../components/UI/ItemMenu";
import { useHistory, createSearchParams, useLocation } from "react-router-dom";
import { defaultReducer, usePageState, useQuery } from "../../Utils";
import { PopUpWrapper } from "../../components/PopUpWrapper";
import { DeviceStatusMenu } from "../../components/UI/DeviceStatusMenu";
import { GetWindowState } from "../../Utils";
import { Box, Typography } from "@mui/material";
import { Translate, translate } from "react-i18nify";
import { ReduceScreenBrightness } from "../../components/UI/ReduceScreenBrightness";
import { BlindVitalValues } from "../../components/UI/BlindVitalValues";
import { PinMenu, PIN_ROLE } from "../../components/UI/PinMenu";
import { SelectInputMenu } from "../../components/UI/SelectInputMenu";

export const EDIT_PROFILE_MODE = {
  MODE_DEFAULT: "MODE_DEFAULT",
  MODE_EDIT_VALUE: "EDIT_VALUE",
};

const findActiveIndex = (value, values) => {
  return values.indexOf(value);
};

export const ScreenSettings = (props) => {
  const generateMenuItems = (props) => {
    return [
      {
        label: "ReduceScreenBrightnessAfter",
        window: "ReduceScreenBrightnessAfter",
        value: props.pro?.reduceScreenBrightness / 1000 / 60 / 60,
        unit: "min",
        disable: true,
      },
      { 
        label: "PauseScreenType", 
        window: "PauseScreenType",
        // selectInput: true,
        local: true,
        value: props?.pro?.pauseScreenValues?.type,
        possibleValues: ["Vitals", "Logo"], 
      },
      { 
        label: "GoToPauseScreenAfter", 
        window: "GoToPauseScreenAfter", 
        unit: "min",
        selectInput: true,
        local: true,
        value: props?.pro?.pauseScreenValues?.delay / 1000 / 60,
        possibleValues: [120, 60, 30, 20, 10, 5, 1],
      },
      { 
        label: "BlindVitalValues", 
        window: "BlindVitalValues",
        // value: props.pro?.vitalVis 
      },
      
    ];
  };

  const history = useHistory();
  const location = useLocation();
  const state = GetWindowState();
  const [adminConfirm, setAdminConfirm] = useState(false)
  const [popup, setPopUp] = useState(null);
  const [pageState, setPageState] = usePageState(
    defaultReducer,
    state
      ? state
      : {
        menu: {
          LEFT: { label: "Back", route: "admin" },
          UP: null,
          RIGHT: { label: "Select", route: "NAVIGATE_SELECT", local: true },
          MIDDLE: null,
          DOWN: { label: "DOWN", route: "VALUE_DOWN", local: true },
        },
        window: null,
        location: props.pro.location,
        activeItemIndex: 0,
        menuItems: generateMenuItems(props),
        editProfileValueMode: EDIT_PROFILE_MODE.MODE_DEFAULT,
      }
  );

  const setWindowState = (state, windowState) => {
    setPageState((prev) => {
      return {
        ...prev,
        menu: state,
        window: { state: windowState, menu: state },
      };
    });
    props.navigation.setMenu(state);
  };

  const updateNavigationForValue = () => {
    let menu={
      LEFT: { label: "Undo", route: "NAVIGATE_UNDO", local: true  },
      RIGHT: { label: "Save", route: "NAVIGATE_SAVE", local: true },
      MIDDLE: { label: "Value"},
      UP:{ label: "UP", route: "VALUE_UP", local: true },
      DOWN:{ label: "DOWN", route: "VALUE_DOWN", local: true }
    }
    return menu;
  };

    const selectClicked = (state) => {
      if (state.editProfileValueMode == EDIT_PROFILE_MODE.MODE_DEFAULT) {
          let newState = state;
          newState.menu = updateNavigationForValue()
          newState.editProfileValueMode = EDIT_PROFILE_MODE.MODE_EDIT_VALUE
          newState.savedMenuItems = JSON.parse(JSON.stringify(state.menuItems))
          return newState;
      }
      return state;
    };

  const handleRight = (navigator, action, menu) => {
    setPageState((prevState) => {
      if (prevState.menuItems[prevState.activeItemIndex].window != null) {
        return {
          ...prevState,
          windowName: prevState.menuItems[prevState.activeItemIndex].window
        };
      } else if (prevState.menuItems[prevState.activeItemIndex].route != null) {
        history.push(
          prevState.menuItems[prevState.activeItemIndex].route
        );
        return prevState;
      }
      else if (prevState.menuItems[prevState.activeItemIndex]?.selectInput) {
        return selectClicked(prevState)
        // return newstate;
      }
      else {
        return prevState
      }
    });
  }

  const handleLeft = (navigator, action, menu) => {
    if (pageState.window != null) {
      if (menu[action.button].route == "NAVIGATE_Cancel")
        setPageState((prev) => {
          return { ...prev, window: null };
        });
      if (menu[action.button].route == "NAVIGATE_Clear")
        setPageState((prev) => {
          return { ...prev, window: null };
        });
      return;
    }
    else {
      setPageState((prevState) => {
        return {
          ...prevState,
          window: {
            name: prevState.menuItems[prevState.activeItemIndex].window,
          },
        };
      });
    }
  };

  const handleDown = (navigator, action, menu) => {
    if (pageState.window != null) {
      return;
    }
    setPageState((prev) => {
      let prevIndex = prev.activeItemIndex;
      let menuItems = prev.menuItems;
      let newActiveIndex =
        prevIndex < menuItems.length - 1 ? prevIndex + 1 : prevIndex;
      return { ...prev, activeItemIndex: newActiveIndex };
    });
  };


  const handleUp = (navigator, action, menu) => {
    setPageState((prev) => {
      let prevIndex = prev.activeItemIndex;
      let newActiveIndex = prevIndex > 0 ? prevIndex - 1 : prevIndex;
      return { ...prev, activeItemIndex: newActiveIndex };
    });
  };

  const renderPopUp = (state) => {
    let popup = null;
    switch (state.windowName){
      case "ReduceScreenBrightnessAfter":
        popup = (
        <ReduceScreenBrightness
          name={"ReduceScreenBrightness"}
          value={props.pro.reduceScreenBrightness}
          state={state.window?.state}
          pro={props.pro}
          setState={setWindowState}
          label={"ScreenDimmingDelay"}
          onComplete={(newValue) => {
            console.log("screen dim",newValue)
            props.pro?.setReduceScreenBrightness(newValue * 60 * 60 * 1000)
            setPageState((prev) => {
              return {
                ...prev, 
                updated: null,
                windowName: null,
                window: null,
              }
            })
            updateDefaultNavigation();
          }}
          onCancel={() => {
            setPageState((prev) => {
              return {
                ...prev, 
                updated: null,
                windowName: null,
                window: null,
              }
            })
            updateDefaultNavigation()
          }}
        />)
        break;
      case "PauseScreenType":
        popup = (
          <SelectInputMenu
            values={state.menuItems[state.activeItemIndex].possibleValues}
            name={"PauseScreenType"}
            label={translate("PauseScreenType")}
            onComplete={(newValue) => {
              props.pro?.setPauseScreenType(newValue)
              setPageState((prev) => {
                return {
                  ...prev,
                  windowName: null,
                  window: null,
                  updated: null,
                };
              });
              updateDefaultNavigation();
            }}
            onCancel={() => {
              setPageState((prev) => {
                return {
                  ...prev,
                  windowName: null,
                  window: null,
                  updated: null,
                };
              });
              updateDefaultNavigation();
            }}
            value={state.menuItems[state.activeItemIndex].value}
            format={(data) => data} //Data is already a string 
            setState={setWindowState}
            menu={state?.window?.menu}
            state={state?.window?.state}
          />
        );
        break;
      case "GoToPauseScreenAfter":
        popup = (
          <SelectInputMenu
            values={state.menuItems[state.activeItemIndex].possibleValues}
            name={"GoToPauseScreenAfter"}
            label={translate("GoToPauseScreenAfter")}
            onComplete={(newValue) => {
              props.pro?.setPauseScreenDelay(newValue * 1000 * 60)
              setPageState((prev) => {
                return {
                  ...prev,
                  windowName: null,
                  window: null,
                  updated: null,
                };
              });
              updateDefaultNavigation();
            }}
            onCancel={() => {
              setPageState((prev) => {
                return {
                  ...prev,
                  windowName: null,
                  window: null,
                  updated: null,
                };
              });
              updateDefaultNavigation();
            }}
            value={state.menuItems[state.activeItemIndex].value}
            format={(data) => data + " min"} 
            setState={setWindowState}
            menu={state?.window?.menu}
            state={state?.window?.state}
          />
        );
        break;
      case "BlindVitalValues":  
        if(adminConfirm){
          popup = (
            <BlindVitalValues
              name={"BlindVitalValues"}
              pro={props.pro}
              setState={setWindowState}
              state={state.window?.state}
              onCancel={() => {
              setAdminConfirm(false)
              setPageState((prev) => {
                return {
                  ...prev, 
                  updated: null,
                  windowName: null,
                  window: null,
                }
              })
              updateDefaultNavigation()
            }}
            />
          ) 
        } else {
          popup = (
            <PinMenu
              name={"setPin"}
              label={translate("InputAdminPin")}
              setState={setWindowState}
              role={PIN_ROLE.VERIFY_PIN}
              currentPin={props.pro.pin.usb}
              menu={state?.window?.menu}
              state={state?.window?.state}
              onComplete={(eneteredPin) => {
                if (eneteredPin == props.pro.pin.usb) {
                  setAdminConfirm(true)
                  setPageState((prev) => {
                    return {
                      ...prev,
                      windowName: "BlindVitalValues",
                      window: "BlindVitalValues",
                    };
                  });
                }
              }}
              onCancel={() => {
                setPageState((prev) => {
                  return {
                    ...prev,
                    windowName: null,
                    window: null,
                  };
                });
                updateDefaultNavigation()
              }}
            />
          )
        }
        break;
    }
    return popup;
  }

  const localNavigation = (navigator, action, menu) => {
    if (action.type == "CLICK") {
      if (pageState.window?.state?.windowNavigation != null) {
          pageState.window?.state?.windowNavigation(
            navigator,
            action,
            menu,
            pageState?.window?.state
          );
        return;
      }

      if(pageState.editProfileValueMode === EDIT_PROFILE_MODE.MODE_EDIT_VALUE){
        switch (menu[action.button].route){
          case "VALUE_UP":
            valueUp(pageState)
            break;
          case "VALUE_DOWN":
            valueDown(pageState)
            break;
          case "NAVIGATE_UNDO":
            undoClicked(pageState)
            break;
          case "NAVIGATE_SAVE": 
            saveClicked(pageState);
            break;
        }
      }else{
        switch (action.button) {
          case "DOWN":
            handleDown(navigator, action, menu);
            break;
          case "LEFT":
            handleLeft(navigator, action, menu);
            break;
          case "UP":
            handleUp(navigator, action, menu);
            break;
          case "RIGHT":
            handleRight(navigator, action, menu)
            break;
        }
      }
    }
  };

  const cycleValues=(direction,values,currentValue,menuIndex)=>{
    let newIndex;
    if(direction=="down"){
      let index=findActiveIndex(currentValue,values[menuIndex].possibleValues)
      newIndex = index - 1;
      if (newIndex < 0) {
        newIndex = values[menuIndex].possibleValues.length - 1;
      }
    }
    else if(direction=="up"){
      let index=findActiveIndex(currentValue,values[menuIndex].possibleValues)
      newIndex = index + 1;
      if (newIndex === values[menuIndex].possibleValues.length) {
        newIndex = 0;
      }
    }
    return newIndex;
  }

  const valueUp = (state) => {
    let newValue=cycleValues("up",state.menuItems,state.menuItems[state.activeItemIndex].value,state.activeItemIndex)
    let menuItems=[...state.menuItems];
    menuItems[state.activeItemIndex].value = menuItems[state.activeItemIndex].possibleValues[newValue]
  }

  const valueDown = (state) => {
      let newValue=cycleValues("down",state.menuItems,state.menuItems[state.activeItemIndex].value,state.activeItemIndex)
      let menuItems=[...state.menuItems];
      menuItems[state.activeItemIndex].value=menuItems[state.activeItemIndex].possibleValues[newValue]
  }

  const undoClicked = (state) => {
    let newState = state;
    newState.editProfileValueMode = EDIT_PROFILE_MODE.MODE_DEFAULT
    newState.menuItems = state.savedMenuItems
    newState.savedMenuItems = null
    setPageState(newState)
    // updateDefaultNavigation()
  }

  const saveClicked = (pageState) => {
    if (pageState.editProfileValueMode === EDIT_PROFILE_MODE.MODE_EDIT_VALUE) {
      let newState = pageState
      const newValue = pageState.menuItems[pageState.activeItemIndex].value
      switch (pageState.menuItems[pageState.activeItemIndex].label){
        case "PauseScreenType":
          props.pro?.setPauseScreenType(newValue)
          break;
        case "GoToPauseScreenAfter":
          props.pro?.setPauseScreenDelay(newValue * 60 * 1000) // the value is in min, and we need milliseconds
          break;
      }

      newState.editProfileValueMode = EDIT_PROFILE_MODE.MODE_DEFAULT
      newState.savedMenuItems=null;
      newState.updatedMenuItems=null
      setPageState(newState)
      // updateDefaultNavigation()
    }
  }

  const updateDefaultNavigation = () => {
    if(pageState.editProfileValueMode == EDIT_PROFILE_MODE.MODE_DEFAULT){
      setPageState((old) => {
        old.menu.LEFT= { label: "Back", route: "admin" };
        old.menu.RIGHT= { label: "Select", route: "NAVIGATE_SELECT", local: true }
        const showUpButton = old.activeItemIndex > 0;
        const showDownButton = old.activeItemIndex < old.menuItems?.length - 1;
        old.menu.MIDDLE = null;
        old.menu.UP = showUpButton
          ? { label: "UP", route: "VALUE_UP", local: true }
          : null;
        old.menu.DOWN = showDownButton
          ? { label: "DOWN", route: "VALUE_DOWN", local: true }
          : null;
        return old;
      });
    }
  };

  useEffect(() => {
    let pop = renderPopUp(pageState);
    setPopUp(pop);

  }, [pageState.windowName, pageState.window]);
    
  useEffect(() => {

    props.navigation.setMenu(pageState.menu)
    props.navigation.addLocalNavigation(localNavigation)
    return () => {
      props.navigation.addLocalNavigation(null);
    };
    
  }, [pageState])

  useEffect(() => {
    props.navigation.setMenu(pageState.menu)
  }, [pageState.menu])

  useEffect(() => {
    if(pageState.editProfileValueMode === EDIT_PROFILE_MODE.MODE_DEFAULT){
      updateDefaultNavigation()
    }
  }, [pageState.activeItemIndex, pageState.editProfileValueMode]);
  
  useEffect(() => {
    setPageState((prev) => {
      return {
        ...prev,
        menuItems: generateMenuItems(props),
      }
    })
  }, [props.pro?.reduceScreenBrightness, props?.pro?.pauseScreenValues.type, props?.pro?.pauseScreenValues.delay]);

    return (
      <PopUpWrapper popup={popup} >
        <ItemMenu
          margin={5}
          activeItemIndex={pageState?.activeItemIndex}
          width="60%"
          menuItems={pageState?.menuItems}
        />
      </PopUpWrapper>
    )
}

